import {
  Fade,
  Modal,
  SvgIcon,
  Box,
  useTheme,
  SxProps
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IDarkTheme } from "styles/darkTheme";

type IModal = {
  openModal: boolean;
  handleClose: () => void;
  children: React.ReactElement<any, any>;
  bodyStyles?: SxProps;
  closeStyles?: SxProps;
};

const ModalComponent = ({
  openModal,
  handleClose,
  children,
  bodyStyles,
  closeStyles
}: IModal) => {
  const theme = useTheme<IDarkTheme>();

  return (
    <Modal
      disableAutoFocus
      open={openModal}
      onClose={handleClose}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex"
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={openModal}>
        <Box
          sx={{
            width: "75%",
            backgroundColor: theme.colors.semantic.semantic_white,
            height: "80%",
            borderRadius: "8px",
            padding: "1rem",
            ...bodyStyles
          }}
        >
          <SvgIcon
            sx={{
              marginTop: "5px",
              marginLeft: "3.6px",
              "&:hover": {
                cursor: "pointer"
              },
              ...closeStyles
            }}
            component={CloseRoundedIcon}
            onClick={handleClose}
          />

          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ModalComponent;
